import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const fetchStateListingApi = createApi({
  reducerPath: "fetchStateListingApi",
  baseQuery: fetchBaseQuery({
    baseUrl:
      "https://firestore.googleapis.com/v1/projects/clone-realtor-557bf/databases/(default)/documents",
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    }
  }),
  tagTypes: ["LISTINGS"],
  endpoints: (builder) => ({
    getOfferListings: builder.query({
      query: () => ({
        url: ":runQuery",
        method: "POST",
        body: {
          structuredQuery: {
            from: [{ collectionId: "allListings" }],
            where: {
              fieldFilter: {
                field: { fieldPath: "offer" },
                op: "EQUAL",
                value: { stringValue: "yes" }
              }
            }
          }
        }
      }),
      providesTags: [{ type: "LISTINGS", id: "OFFER" }],
      transformResponse: (response: any) =>
        response
          .filter((doc: any) => doc.document)
          .map((doc: any) => ({
            id: doc.document.name.split("/").pop(),
            ...Object.fromEntries(
              Object.entries(doc.document.fields).map(([k, v]: any) => [
                k,
                Object.values(v)[0]
              ])
            )
          }))
    }),
    getRentListings: builder.query({
      query: () => ({
        url: ":runQuery",
        method: "POST",
        body: {
          structuredQuery: {
            from: [{ collectionId: "allListings" }],
            where: {
              fieldFilter: {
                field: { fieldPath: "sellRent" },
                op: "EQUAL",
                value: { stringValue: "rent" }
              }
            }
          }
        }
      }),
      providesTags: [{ type: "LISTINGS", id: "RENT" }],
      transformResponse: (response: any) =>
        response
          .filter((doc: any) => doc.document)
          .map((doc: any) => ({
            id: doc.document.name.split("/").pop(),
            ...Object.fromEntries(
              Object.entries(doc.document.fields).map(([k, v]: any) => [
                k,
                Object.values(v)[0]
              ])
            )
          }))
    }),

    getSellListings: builder.query({
      query: () => ({
        url: ":runQuery",
        method: "POST",
        body: {
          structuredQuery: {
            from: [{ collectionId: "allListings" }],
            where: {
              fieldFilter: {
                field: { fieldPath: "sellRent" },
                op: "EQUAL",
                value: { stringValue: "sell" }
              }
            }
          }
        }
      }),
      providesTags: [{ type: "LISTINGS", id: "SELL" }],
      transformResponse: (response: any) =>
        response
          .filter((doc: any) => doc.document)
          .map((doc: any) => ({
            id: doc.document.name.split("/").pop(),
            ...Object.fromEntries(
              Object.entries(doc.document.fields).map(([k, v]: any) => [
                k,
                Object.values(v)[0]
              ])
            )
          }))
    })
  })
});

export const {
  useGetOfferListingsQuery,
  useGetRentListingsQuery,
  useGetSellListingsQuery
} = fetchStateListingApi;
